import * as React from "react";

import { getTestAttributes } from "@common/utils/tests";

import { MODULE_NAME } from "@modules/invite-status/constants/shared";
import Dropdown from "@common/containers/fields/Dropdown";

import "./dropdown-list.styles.scss";

type Option = { value: string; label: string };

type DropdownListProps = {
  label: string;
  options: Array<Option>;
  value?: Option["value"];
  onChange: (value: Option["value"]) => void;
  id: string;
};

export const DropdownList: React.FC<DropdownListProps> = (props) => {
  const { label, value = "", options, onChange, id } = props;

  return (
    <div className="InvitesFilterDropdownList">
      <h6 className="InvitesFilterDropdownList__title">{label}</h6>
      <Dropdown
        withEmptyOption
        className="InvitesFilterDropdownList__field"
        inputProps={getTestAttributes(MODULE_NAME, id, "dropdown")}
        selectedValue={value}
        searchable={false}
        options={options}
        optionsHeight={100}
        onValueChanged={onChange}
      />
    </div>
  );
};
